import { useEffect, useCallback } from 'react';

import Hotjar from '@hotjar/browser';
import useEnv from '@zenbusiness/application-commons-env';

import { isProduction } from '#client/utils/environment';

const useHotJarEvent = () => {
  const { HOTJAR_ENABLED } = useEnv();

  const sendEvent = useCallback(
    (eventName) => {
      if (!HOTJAR_ENABLED || !Hotjar.isReady()) {
        return;
      }

      Hotjar.event(eventName);
    },
    [HOTJAR_ENABLED]
  );

  return sendEvent;
};

const useInitHotJar = () => {
  const { HOTJAR_ID, HOTJAR_SV, DEPLOY_ENV, HOTJAR_ENABLED } = useEnv();

  useEffect(() => {
    if (!HOTJAR_ID || !HOTJAR_SV || !DEPLOY_ENV || !HOTJAR_ENABLED || Hotjar.isReady()) {
      return;
    }

    Hotjar.init(HOTJAR_ID, HOTJAR_SV, {
      debug: !isProduction(DEPLOY_ENV)
    });
  }, [DEPLOY_ENV, HOTJAR_ENABLED, HOTJAR_ID, HOTJAR_SV]);
};

export default useInitHotJar;
export { useHotJarEvent };
